<div class="loading">
  <img src="/assets/loading.gif">
</div>
